import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  IconButton,
  Button,
} from "@mui/material";
import CustomButton from "components/CustomButton";
import AddIcon from "@mui/icons-material/Add";
import { feedbackMockData } from "../../constants";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FeedbackForm from "components/Feedback/FeedbackForm";
import PaginationComponent from "components/Pagination";
import { FeedbackActionButton } from "components/ActionButton/FeedbackActionButton";

const Feedback = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [formOpen, setFormOpen] = useState<boolean>(false);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFeedbackFormOpen = (e: React.MouseEvent<HTMLElement>) => {
    setFormOpen(true);
  };

  const handleFeedbackFormClose = () => {
    setFormOpen(false);
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" alignItems="center" justifyContent="space-between" mt={3}>
        <Typography variant="h5" fontSize="24px" fontWeight={800}>
          Feedback
        </Typography>
        <CustomButton
          startIcon={<AddIcon />}
          title="Give Feedback"
          sx={{ py: 1 }}
          onClick={handleFeedbackFormOpen}
        />
      </Box>
      <TableContainer component={Paper} elevation={3} sx={{ mt: 3, mb: 4 }}>
        <Table aria-label="simple table">
          <TableHead sx={{ backgroundColor: "#146ED2" }}>
            <TableRow>
              <TableCell align="left">
                <Typography variant="h6" sx={{ fontWeight: 800, fontSize: "14px", color: "white" }}>
                  AVATAR
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="h6" sx={{ fontWeight: 800, fontSize: "14px", color: "white" }}>
                  REVIEW
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="h6" sx={{ fontWeight: 800, fontSize: "14px", color: "white" }}>
                  DATE
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="h6" sx={{ fontWeight: 800, fontSize: "14px", color: "white" }}>
                  DETAILS
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="h6" sx={{ fontWeight: 800, fontSize: "14px", color: "white" }}>
                  ACTION
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {feedbackMockData.map(({ id, name, avatar, feedback, date }) => (
              <TableRow key={id} sx={{ minHeight: "50px" }}>
                <TableCell component="th" scope="row">
                  <Avatar
                    src={avatar}
                    alt={name}
                    sx={{ width: "50px", height: "50px", borderRadius: "4px" }}
                  />
                </TableCell>
                <TableCell align="left">
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      ml: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "14px",
                        fontWeight: 800,
                        opacity: 0.8,
                      }}
                    >
                      {name}
                    </Typography>
                    <Typography variant="h6" sx={{ fontSize: "14px", opacity: 0.8 }}>
                      {feedback}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="h6" fontSize="14px" sx={{ opacity: 0.6, fontWeight: 800 }}>
                    {date}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{
                      color: "black",
                      backgroundColor: "#F5F6F9",
                      borderColor: "gray",
                      opacity: 0.7,
                      "&:hover": { borderColor: "gray" },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "12px",
                        fontWeight: "800",
                        textTransform: "none",
                        opacity: 0.8,
                      }}
                    >
                      View details
                    </Typography>
                  </Button>
                </TableCell>
                <TableCell align="left">
                  <IconButton onClick={(e) => handleMenuOpen(e)}>
                    <MoreHorizIcon
                      sx={{
                        backgroundColor: "#F5F6F9",
                        width: 26,
                        height: 26,
                        borderRadius: "100%",
                      }}
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <FeedbackActionButton anchorEl={anchorEl} open={open} handleClose={handleMenuClose} />
      <FeedbackForm formOpen={formOpen} handleFeedbackFormClose={handleFeedbackFormClose} />
      <PaginationComponent />
    </Box>
  );
};

export default Feedback;
